import { ClassCookie } from 'Modules'

class EmailConfirmationCookieClass extends ClassCookie {
	private readonly COOKIE_EMAIL_KEY = 'Emailconfirmationcode'

	public getCode(): string {
		return this.get(this.COOKIE_EMAIL_KEY)
	}

	public setCode(
		value: string,
		options = {
			'max-age': 86400,
			SameSite: 'Strict',
			Secure: true,
			Path: '/',
		}
	): void {
		this.set(this.COOKIE_EMAIL_KEY, value, options)
	}

	public deleteCode(): void {
		this.delete(this.COOKIE_EMAIL_KEY)
	}
}

export const EmailConfirmationCookie = new EmailConfirmationCookieClass()
